
<div>
  <HelperText v-if="helperText" :id="id" :text="helperText" :status="status" class="mb-24" />
  <fieldset class="toggle-token-group grid-cols-2" :class="gridClasses" tabindex="-1">
    <legend class="sr-only">{{ legend }}</legend>
    <ToggleToken
      v-for="(token, i) in tokens"
      :key="`${id}-${i}`"
      v-model="token.value"
      :checkboxId="`${id}-${i}`"
      :status="status"
      :text="token.text"
      :icon="token.icon"
      :iconHeight="token.iconHeight"
      :iconWidth="token.iconWidth"
      :iconType="token.iconType"
      :ariaLabel="token.ariaLabel"
      @update:modelValue="updateValue"
    >
      <template v-if="token.formattedText || token.pill" #formattedText>
        <Pill v-if="token.pill" :color="token.pill.color">{{ token.pill.text }}</Pill>
        <span v-if="token.formattedText" v-html="token.formattedText" />
      </template>
    </ToggleToken>
  </fieldset>
</div>
